<template>
	<div class="w-100 p-3" style="height: 75vh;overflow-y: auto;">
		<div class="d-flex flex-justify-between flex-align-end">
			<!--FILTRI A SX-->
			<div class="row">
				<div class="filter-left">
					<label class="text-bold">{{ $t("Search") }}</label>
					<input v-model="filters.nameToSearch" type="text" data-role="input" data-clear-button="true" :placeholder="$t('Please enter at least 4 characters to start the search.')">
				</div>
				<div class="filter-left">
					<label class="text-bold">{{ $t("Vendor") }}</label>
					<select class="select  text-small w-auto" v-model="filters.selectedVendor">
						<option value="">{{ $t("All") }}</option>
						<option v-for="pub in filters.vendorList" :value="pub">{{ pub }}</option>
					</select>
				</div>
			</div>
			<!--OPERAZIONI A DX-->
			<div v-if="lastScanStr != ''" class="col-auto">
				<div class="col-auto ml-auto d-flex flex-justify-end">
				<!--<button class="mif-refresh mif-3x button" @click="refreshSWList()" :disabled="disableRefresh"></button>-->
				<button v-if="lastScan != null" class="button mr-2" @click="refreshSWList()" :disabled="!$root.connectionsStates[idPC] || disableRefresh" :title="$t('Last scan : ') + lastScanStr">
				<span class="mif-play mif-2x mr-1"></span>
				<span>{{ $t("Scan now") }}</span>
				</button>
				<!--<small class="mt-1">{{ $t("Latest software scan") }} : {{ lastScanStr }}</small>-->
				<!--<button class="mif-refresh mif-3x button" @click="refreshSWList()" :disabled="disableRefresh"></button>-->
				<button v-if="swList.length != 0" class="button secondary" @click="exportInCSV(swList)">
				<span class="mif-download2 mif-2x mr-1"></span>
				<span>{{ $t("Export in .csv") }}</span>
				</button>
				</div>
				<small class="p-0 mr-1 col-auto">{{ $t("Latest software scan") }} : {{ lastScanStr }}</small>
			</div>
		</div>
		
		<NoDataAvailable v-if="swList.length == 0" :message="$t('No software available')" />

		<div>
			<table class="bg-white border table striped compact overflow" v-if="swList.length != 0" >
				<thead>
				<tr>
					<th>{{ $t("Name") }}</th>
					<th>{{ $t("Version") }}</th>
					<th>{{ $t("Vendor") }}</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="(sw, index) in swList" :key="index" 
					v-show="(filters.nameToSearch == '' || sw.name.toLowerCase().contains(filters.nameToSearch.toLowerCase())) && ['', sw.vendor].includes(filters.selectedVendor)">
					<td>{{ sw.name }}</td>
					<td>{{ sw.version }}</td>
					<td>{{ sw.vendor }}</td>
				</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
import NoDataAvailable from '../utils/NoDataAvailable.vue';

export default {
	name: "SoftwareInventory",
	components:{
		NoDataAvailable
	},
	props:{
		idPC:{
			type:String,
			required:true
		}
	},
	data() {
		return {
			swList: [],
			lastScan: null,
			lastScanStr: "",
			disableRefresh: false,
			disableRefresh_timer: null,
			filters: {
				vendorList: [],
				selectedVendor: "",
				nameToSearch: ""
			}
		}
	},
	methods: {
		getSWList(refresh) {
			if (refresh) {
				this.swList.clear();
				this.filters.vendorList.clear();
			}

			this.$api.getSoftwareList(this.idPC).then((res) => {
				this.swList.push(...res.sw_inventory);
				if (this.swList.length!=0) {
					this.filters.vendorList.push(...this.swList.map(sw => sw.vendor).distinctBy(null).sort());
				}


				if (res.dt_last_scan_utc==null) {
					this.lastScan=null;
					this.lastScanStr="";
					return;
				}

				this.lastScan=this.$moment.utc(res.dt_last_scan_utc, "YYYYMMDDHHmmss", true).local().toDate();
				this.lastScanStr=res.dt_last_scan_utc.toLocalDate();

				if (this.disableRefresh_timer!=null) {
					clearInterval(this.disableRefresh_timer);
					this.disableRefresh_timer=null;
				}

				this.disableRefresh=Date.now()-this.lastScan<5*60*1000;
				this.disableRefresh_timer=setInterval(
					() => {
						this.disableRefresh=Date.now()-this.lastScan<5*60*1000;
					}, 10000
				);


			});

		},

		async refreshSWList() {
			var ok=await this.$root.socket("refreshswinventory");
			if (ok)
				this.getSWList(true);

		},

	},
	beforeDestroy: async function() {
		if (this.disableRefresh_timer) {
			clearInterval(this.disableRefresh_timer);
		}
	}
}
</script>